// src/theme/components/text.js
// Faz 2 · Genisletilmis Text component'i.
// Mevcut size'lar (xs, sm, md, lg, xl) AYNEN korunur.
// Yeni: 19 semantic variant · display/headline/title/subtitle/sectionHeading/
// body/bodyLarge/bodySmall/reading/label/caption/hint/overline/micro/
// numeric/numericLarge/code/link/buttonLg/buttonMd/buttonSm.
// Variant'lar theme/tokens/typography.js icindeki typographySemantics ile uyumludur.

const Text = {
  baseStyle: {
    fontFamily: 'body',
    color: 'textPrimary',
  },

  // Mevcut size'lar · geriye uyumluluk icin AYNEN korundu.
  sizes: {
    'xl': {
      fontSize: { base: '1.1875rem', md: '1.25rem' },
      lineHeight: { base: '1.5', md: '1.6' },
    },
    'lg': {
      fontSize: { base: '1.0625rem', md: '1.125rem' },
      lineHeight: { base: '1.5', md: '1.6' },
    },
    'md': {
      fontSize: { base: '0.9375rem', md: '1rem' },
      lineHeight: { base: '1.5', md: '1.6' },
    },
    'sm': {
      fontSize: { base: '0.8125rem', md: '0.875rem' },
      lineHeight: { base: '1.5', md: '1.5' },
    },
    'xs': {
      fontSize: { base: '0.6875rem', md: '0.75rem' },
      lineHeight: { base: '1.5', md: '1.5' },
    },
  },

  // ====================================================================
  // Faz 2 · Yeni semantic variant'lar.
  // Kullanim: <Text variant="label">UYE SAYISI</Text>
  // ====================================================================
  variants: {
    // ===== DISPLAY (landing, marketing, 404) =====
    'display': {
      fontSize: { base: 'display.lg', md: 'display.xl', lg: 'display.2xl' },
      lineHeight: 'display',
      fontWeight: 'extrabold',
      letterSpacing: 'display',
      fontFamily: 'display',
      color: 'textPrimary',
    },
    'displaySmall': {
      fontSize: { base: 'display.md', md: 'display.lg' },
      lineHeight: 'display',
      fontWeight: 'extrabold',
      letterSpacing: 'display',
      fontFamily: 'display',
      color: 'textPrimary',
    },

    // ===== HEADLINE (sayfa basliklari, panel basliklari) =====
    'headline': {
      fontSize: { base: '3xl', md: '4xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'heading',
      color: 'textPrimary',
    },
    'title': {
      fontSize: { base: '2xl', md: '3xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'heading',
      color: 'textPrimary',
    },
    'subtitle': {
      fontSize: { base: 'xl', md: '2xl' },
      lineHeight: 'subheading',
      fontWeight: 'semibold',
      letterSpacing: 'subheading',
      color: 'textPrimary',
    },
    'sectionHeading': {
      fontSize: { base: 'lg', md: 'xl' },
      lineHeight: 'subheading',
      fontWeight: 'semibold',
      letterSpacing: 'subheading',
      color: 'textPrimary',
    },

    // ===== BODY (paragraf, aciklama) =====
    'body': {
      fontSize: 'md',
      lineHeight: 'body',
      fontWeight: 'normal',
      letterSpacing: 'body',
      color: 'textPrimary',
    },
    'bodyLarge': {
      fontSize: 'lg',
      lineHeight: 'body',
      fontWeight: 'normal',
      letterSpacing: 'body',
      color: 'textPrimary',
    },
    'bodySmall': {
      fontSize: 'sm',
      lineHeight: 'body',
      fontWeight: 'normal',
      letterSpacing: 'body',
      color: 'textSecondary',
    },

    // ===== READING (lecture, makale · serif) =====
    'reading': {
      fontSize: { base: 'md', md: 'lg' },
      lineHeight: 'reading',
      fontWeight: 'normal',
      letterSpacing: 'body',
      fontFamily: 'reading',
      color: 'reading.text',
    },

    // ===== LABEL / CAPTION / HINT =====
    'label': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'semibold',
      letterSpacing: 'caption',
      color: 'textSecondary',
    },
    'caption': {
      fontSize: 'xs',
      lineHeight: 'ui',
      fontWeight: 'normal',
      letterSpacing: 'caption',
      color: 'textMuted',
    },
    'hint': {
      fontSize: 'xs',
      lineHeight: 'ui',
      fontWeight: 'normal',
      letterSpacing: 'caption',
      color: 'textMuted',
      fontStyle: 'italic',
    },
    'overline': {
      fontSize: 'xs',
      lineHeight: 'ui',
      fontWeight: 'semibold',
      letterSpacing: 'uppercaseWide',
      textTransform: 'uppercase',
      color: 'textSecondary',
    },
    'micro': {
      fontSize: 'micro',
      lineHeight: 'ui',
      fontWeight: 'normal',
      letterSpacing: 'micro',
      color: 'textMuted',
    },

    // ===== STATUS (form geri bildirim) =====
    'error': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'medium',
      color: 'errorText',
    },
    'success': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'medium',
      color: 'successText',
    },
    'warning': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'medium',
      color: 'warningText',
    },
    'info': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'medium',
      color: 'infoText',
    },

    // ===== NUMERIC (dashboard sayilari, istatistik · tabular figures) =====
    'numeric': {
      fontSize: 'md',
      lineHeight: 'ui',
      fontWeight: 'medium',
      fontFamily: 'numeric',
      fontFeatureSettings: '"tnum", "lnum"',
      letterSpacing: 'body',
      color: 'textPrimary',
    },
    'numericLarge': {
      fontSize: { base: '3xl', md: '4xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      fontFamily: 'numeric',
      fontFeatureSettings: '"tnum", "lnum"',
      letterSpacing: 'heading',
      color: 'textPrimary',
    },
    'numericDisplay': {
      fontSize: { base: 'display.md', md: 'display.lg' },
      lineHeight: 'display',
      fontWeight: 'extrabold',
      fontFamily: 'numeric',
      fontFeatureSettings: '"tnum", "lnum"',
      letterSpacing: 'display',
      color: 'textPrimary',
    },

    // ===== CODE / MONO =====
    'code': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontFamily: 'mono',
      bg: 'reading.code.inlineBg',
      color: 'reading.code.inlineText',
      px: 1.5,
      py: 0.5,
      borderRadius: 'sm',
    },

    // ===== LINK =====
    'link': {
      fontSize: 'inherit',
      fontWeight: 'medium',
      color: 'linkColor',
      cursor: 'pointer',
      transition: 'color var(--motion-duration-fast) var(--motion-ease-apple)',
      _hover: {
        color: 'accentHover',
        textDecoration: 'underline',
      },
    },

    // ===== BUTTON LABEL (Buton i&ccedil;eriginde Text kullanim&iacute;) =====
    'buttonLg': {
      fontSize: 'md',
      lineHeight: 'ui',
      fontWeight: 'semibold',
      letterSpacing: 'caption',
    },
    'buttonMd': {
      fontSize: 'sm',
      lineHeight: 'ui',
      fontWeight: 'semibold',
      letterSpacing: 'caption',
    },
    'buttonSm': {
      fontSize: 'xs',
      lineHeight: 'ui',
      fontWeight: 'semibold',
      letterSpacing: 'caption',
    },

    // ===== PROSE (uzun aciklama paragraflari) =====
    'prose': {
      fontSize: 'md',
      lineHeight: 'tall',
      fontWeight: 'normal',
      letterSpacing: 'body',
      color: 'textPrimary',
    },

    // ===== LEAD (paragraf basi vurgulu giris) =====
    'lead': {
      fontSize: { base: 'lg', md: 'xl' },
      lineHeight: 'tall',
      fontWeight: 'medium',
      letterSpacing: 'body',
      color: 'textPrimary',
    },
  },

  defaultProps: {
    size: 'md',
  },
};

export default Text;
